import { render, staticRenderFns } from "./otros.vue?vue&type=template&id=3f9bd1c0&scoped=true"
import script from "./otros.vue?vue&type=script&lang=js"
export * from "./otros.vue?vue&type=script&lang=js"
import style0 from "./otros.vue?vue&type=style&index=0&id=3f9bd1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9bd1c0",
  null
  
)

export default component.exports